
import '../index.css';

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Link, Route, useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { useAuth } from '../../../shared/AuthContext';
import rolePermissions from '../../../shared/rolePermissions';
import StatusBadge from '../../../components/ui/StatusBadge';

import {
  clearListState,
  getLegacyStoredLimit,
  getStoredListState,
  intFromParam,
  persistListState,
  updateSearchParams,
} from '../../../utils/listState';



import { ChevronLeftIcon, ChevronRightIcon } from '../../../components/ui/AppIcon';






const Component = ({ model }) => {

  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  

  const { user, loadingSession } = useAuth();
  const canViewContent = rolePermissions.hasPermission(user, 'content.view');
  const canManageContent = rolePermissions.hasPermission(user, 'content.manage');





  const persistedState = getStoredListState(`forc.list.${model.slug}.state`);

  const page = intFromParam(searchParams.get('page'), 1);
  const limit = intFromParam(
    searchParams.get('limit'),
    intFromParam(persistedState.limit, getLegacyStoredLimit(`forc.list.${model.slug}.limit`))
  );
  const sort = searchParams.get('sort') ?? persistedState.sort ?? 'updatedAt';
  const order = searchParams.get('order') ?? persistedState.order ?? 'DESC';
  const status = searchParams.get('status') ?? persistedState.status ?? '';

  const extraParams = {};

  const serializedPerState = JSON.stringify({});
  const serializedExtraParams = JSON.stringify(extraParams);

  useEffect(() => {
    const persistedExtraParams = JSON.parse(serializedExtraParams);
    const persistedPerState = JSON.parse(serializedPerState);

    persistListState({
      storageKey: `forc.list.${model.slug}.state`,
      legacyLimitKey: `forc.list.${model.slug}.limit`,
      limit,
      state: {
        limit,
        sort,
        order,
        status,
        ...persistedExtraParams,
        ...persistedPerState,
      },
    });
  }, [model, limit, order, sort, status, serializedPerState, serializedExtraParams]);





  const [rows, setRows] = useState({
    data: [],
    total: 0
  });
  
  useEffect(() => {

    const loadRecords = async () => {
      setLoading(true);
      setError('');
      try {

        const result = {};

        const Factory = require( '../../../records/modules' ).default;

        const requestExtraParams = JSON.parse(serializedExtraParams);

        const response = await Factory( {
          slug: model.slug
        } ).Meta.getRecords( {

        } );

        const rows = response.data || [];

        result.data = rows.map( ( row ) => {

          const result = {};

          result.data = row;

          return result;
        });

        result.total = response.total || 0;

        setRows( result );
      } catch (err) {
        setError(err?.response?.data?.message || err.message || 'Unable to load records.');
      } finally {
        setLoading(false);
      }
    };

    loadRecords();
  }, [ model, limit, order, page, serializedExtraParams, sort, status ]);

  

  const [context, setContext] = useState([]);
  const [contextLoading, setContextLoading] = useState([]);
  
  useEffect(() => {

    const loadContext = async () => {
      setContextLoading(true);
      setError('');
      try {

      } catch (err) {
        setError(`Context Error: ${err?.response?.data?.message || err.message || 'Unable to load Context.'}`);
      } finally {
        setContextLoading(false);
      }
    };

    loadContext();
  }, [ model ]);











  const [deletingId, setDeletingId] = useState('');
  

  const totalPages = useMemo(() => Math.max(1, Math.ceil(rows.total / limit)), [rows.total, limit]);




  
  const RecordListSection = require( '../../../components/record/RecordListSection' ).default;


  
  if (loading) return <p>Loading Records...</p>;

  const {
    handle,
    details
  } = {
    handle: {
      plural: model.plural,
      description: model.description,
    },
    section: model.section,
    slug: model.slug,
    details: {
      slug: model.slug,
      handle: model.handle,
      status: model.status,
      details: model.fields,
    }
  };

  return (
   <RecordListSection
     slug={details.slug}
     single={details.handle.label}
     error={null}
     canCreateContent={true}
      header={{
        title: handle.plural,
        subtitle: handle.description,
        filters: {
          handleResetFilters: () => {
            
          },
          filters: (
            <>
            </>
          ),
        }
      }}
      data={{
      }}
    >


      <section className="table-card">

        <table className="data-table">
          <thead>
            <tr>
              <th>{details.handle.label}</th>
              <th>Status</th>

              {details.details.map( ( field ) => (
                <th key={field.handle}>{field.label}</th>
              ) )}

            </tr>
          </thead>
          <tbody>
            {(rows.data || []).map((model, modelIndex) => (
              <tr key={model?.data?.slug || model?.data?.id || `meta-row-${modelIndex}`}>
                <td>
                  <Link className="inline-link" to={`/${details.slug}/${model.data.slug}`}>
                    {model.data[ details.handle.handle ]}
                  </Link>
                </td>

                <td><StatusBadge value={model.data.status} /></td>

                {details.details.map( ( field ) => {

                  const Components = require( '../../../elements' ).default;

                  const Component = Components.Data.identity( field.field.value );
                  
                  return (
                    <td key={`${model?.data?.slug || model?.data?.id || modelIndex}-${field.handle}`}>
                      <Component.Output handle={field.handle} meta={field.field.meta} record={model} />
                    </td>
                  );
                } )}

              </tr>
            ))}
            {!rows.data?.length ? (
              <tr>
                <td colSpan={2 + (details.details?.length || 0)}>No metadata records found.</td>
              </tr>
            ) : null}
          </tbody>
        </table>

      </section>

    </RecordListSection>
  );
};


export default Component;